module.exports = __webpack_public_path__ + "static/media/Keypad meter_1.2a8f8c98.jpg";